<template>
  <!-- <authorization permissionKey="attendance_note" can="read"> -->
  <v-row dense>
    <v-col>
      <!-- <authorization
          permissionKey="attendance_note"
          can="save"
          v-slot:default="{ authorization }"
        > -->
      <v-row dense align="center">
        <v-col>
          <AddButton :darkColor="darkColor" :attendanceId="attendanceId" />
        </v-col>
      </v-row>
      <!-- </authorization> -->

      <v-row
        no-gutters
        v-for="noteCategory in noteCategories"
        :key="noteCategory.id"
      >
        <v-col>
          <NoteCategory
            :noteCategory="noteCategory.category"
            :notesByCategory="noteCategory.notes"
            :attendanceId="attendanceId"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <!-- </authorization> -->
</template>

<script>
import AddButton from "@/components/attendance/add_button.vue";
import NoteCategory from "@/components/attendance/note_category.vue";

export default {
  name: "AttendanceNotes",
  props: {
    attendanceId: String,
    notes: Array,
    darkColor: Boolean,
  },
  components: {
    AddButton,
    NoteCategory,
  },
  computed: {
    noteCategories() {
      const grouped = this.lodash.groupBy(this.notes, "category.id");

      return this.lodash.map(grouped, (notes) => {
        return {
          category: notes[0].category, 
          notes: notes,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
